module.exports = __webpack_public_path__ + "img/assess-dp.01b229aa.svg";